import _ from 'lodash';
import { gEnums } from '../../enums/globalEnums';
// import {
//   setDefaults,
//   fromAddress,
// } from "react-geocode";
import { fsfn_getGeocodeAddress } from 'global/functions/fbConfig';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useContext } from 'react';

export const geoCodeAddresses = async (apiKey, listData, itemData, callback) => {

  // const response = await fsfn_getGeocodeAddress(itemData.address)

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state } = states
  const { mainFunctions } = app_state

  // console.log('response', response)
  // const { results } = response
  // if (results && results.length === 1) {
  //   const { geometry } = results[0]
  //   const { location } = geometry ?? {}
  //   vldi.mapPosition = location
  //   vldi._updatePosition = true
  //   return vldi
  // }

  // setDefaults({
  //   key: apiKey, // Your API key here.
  //   language: "en", // Default language for responses.
  //   region: "es", // Default region for responses.
  // });

  const getGeocodes = async () => {
    let _listData = {}
    if (itemData) {
      _listData[itemData._itemKey] = itemData
    } else {
      _listData = listData
    }
    const geoCodedItems = await Promise.all(
      Object.keys(_listData).map(async (k) => {
        try {
          const vldi = _listData[k]
          const { address, mapPosition } = vldi
          if (!mapPosition) {
            try {
              // const response = await fromAddress(address) 
              const response = await fsfn_getGeocodeAddress(address, mainFunctions)
              const { results } = response
              if (results && results.length === 1) {
                const { geometry } = results[0]
                const { location } = geometry ?? {}
                vldi.mapPosition = location
                vldi._updatePosition = true
                return vldi
              }
            } catch (error) {
              console.log('e', error)
            }

          } else {
            return vldi
          }
        } catch (error) {
          return null
        }
      })
    );
    return geoCodedItems
  }

  const x = await getGeocodes()
  callback(x)
}

export const geoCodeAddress = (maps, mapDetails, onGeoResults, autoUpdateMapPositions, updateProps, firestore_handlers) => {
  const geocoder = new maps.Geocoder();
  if (mapDetails.address && mapDetails.address !== 'undefined') {
    geocoder.geocode({ 'address': mapDetails.address }, function (res, status) {
      if (status === 'OK') {
        const position = {
          lat: res[0].geometry.location.lat(),
          lng: res[0].geometry.location.lng()
        }
        mapDetails.mapPosition = position
        onGeoResults && onGeoResults(mapDetails)
        if (autoUpdateMapPositions && updateProps) {
          const { paps_state, itemData, viewItem } = updateProps
          if (itemData) {
            const { handleUpdate_firestoreData } = firestore_handlers ?? {}
            if (handleUpdate_firestoreData) {
              itemData.mapPosition = position
              const udp = {
                id: itemData.id,
                viewKey: itemData.id,
                itemData,
                modifyType: gEnums.dataUpdateTypes.updateDoc,
                dataUpdateType: gEnums.dataUpdateTypes.updateDoc,
                vit: viewItem.key,
              }
              handleUpdate_firestoreData(null, paps_state, udp)
            }
          }
        }
      } else {
        mapDetails.error = status
        onGeoResults && onGeoResults(mapDetails)
      }
    });
  }
}

export const geoCodeLatLng = (google, mapDetails, onGeoResults) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ 'location': mapDetails.location }, function (results, status) {
    if (status === 'OK') {
      if (results[0]) {
        const { formatted_address } = results[0]
        mapDetails.mapPosition = {
          lat: mapDetails.location.lat(),
          lng: mapDetails.location.lng()
        }
        mapDetails.address = formatted_address
        mapDetails.name = mapDetails.address
        try {
          const spl = formatted_address.split(',')
          const sspl = spl[2].trim().split(' ')
          mapDetails.street = spl[0]
          mapDetails.city = spl[1]
          mapDetails.state = sspl[0]
          mapDetails.zip = sspl[1]
        } catch (error) {
          // split failed 
        }
        onGeoResults(mapDetails)
      } else {
        mapDetails.error = 'No results found'
        onGeoResults(mapDetails)
      }
    } else {
      mapDetails.error = 'No results found'
      onGeoResults(mapDetails)
    }
  });
}

export const getAddress = (itemData) => {
  let street = ''
  let city = ''
  let state = ''
  let zip = ''
  street = street + itemData.address ? itemData.address : ''
  city = city + (itemData.city ? ' ' + itemData.city : '')
  state = state + (itemData.state ? ', ' + itemData.state : '')
  zip = zip + (itemData.zip ? ' ' + itemData.zip : '')
  return {
    name: itemData.name,
    street: street,
    city: city,
    address: street + city + state + zip,
    mapPosition: itemData.mapPosition
  }
}

export const getMapDetails = (itemData, pr) => {
  if (itemData) {
    let name = itemData.name
    if (itemData.locations && itemData.locations[0]) {
      name = itemData.locations[0]
    }
    if (pr && pr.listOf) {
      if (itemData[pr.listOf]) {
        name = itemData[pr.listOf]
        if (name && _.isArray(name)) {
          name = name[0]
        }
      }
    }
    let itemAddress = getAddress(itemData)
    if (!itemAddress.street && itemData.mapItem) { itemAddress = getAddress(itemData.mapItem) }
    return {
      name: name,
      street: itemAddress.street,
      city: itemAddress.city,
      address: itemAddress.street + itemAddress.city,
      mapPosition: itemData.mapPosition,
      location: name ? name : null
    }
  }
  return {
    name: '',
    street: null,
    city: null,
    address: null,
    mapPosition: null,
    location: null
  }
}

export const findLocations = (viewListData, mapLists, listOfProp) => {
  const listOf = listOfProp.listOf
  if (listOf) {
    listOf.forEach(l => {
      if (mapLists && mapLists[l]) {
        const ml = mapLists[l]
        viewListData.forEach(itemData => {
          if (itemData.locations && itemData.locations[0]) {
            const item = _.find(Object.values(ml), { 'name': itemData.locations[0] })
            if (item && item.mapPosition) {
              itemData.mapPosition = item.mapPosition
            }
          }
        })
      }
    })
  }
}

export const findLocation = (itemData, mapLists, pr) => {
  const listOf = pr.listOf
  if (listOf) {
    if (_.isArray(listOf)) {
      listOf.forEach(l => {
        if (mapLists && mapLists[l]) {
          const ml = mapLists[l]
          if (itemData.locations && itemData.locations[0]) {
            let item = _.find(Object.values(ml), { 'name': itemData.locations[0] })
            if (!item) {
              item = _.find(ml, { 'name': itemData.locations[0] })
            }
            if (item && item.mapPosition) {
              itemData.mapPosition = item.mapPosition
              itemData.mapItem = item
            }
          }
          if (itemData.hotels && itemData.hotels[0]) {
            let item = _.find(Object.values(ml), { 'name': itemData.hotels[0] })
            if (!item) {
              item = _.find(ml, { 'name': itemData.hotels[0] })
            }
            if (item && item.mapPosition) {
              itemData.mapPosition = item.mapPosition
              itemData.mapItem = item
            }
          }
        }
      })
    } else {
      if (mapLists && mapLists[listOf]) {
        const ml = mapLists[listOf]
        if (itemData.locations && itemData.locations[0]) {
          let item = _.find(Object.values(ml), { 'name': itemData.locations[0] })
          if (!item) {
            item = _.find(ml, { 'name': itemData.locations[0] })
          }
          if (item && item.mapPosition) {
            itemData.mapPosition = item.mapPosition
            itemData.mapItem = item
          }
        }
        if (itemData.hotels && itemData.hotels[0]) {
          let item = _.find(Object.values(ml), { 'name': itemData.hotels[0] })
          if (!item) {
            item = _.find(ml, { 'name': itemData.hotels[0] })
          }
          if (item && item.mapPosition) {
            itemData.mapPosition = item.mapPosition
            itemData.mapItem = item
          }
        }
      }
    }
  }
}

export const getLocationFromAddress = (google, address, onGeoResults) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ 'address': address }, function (results, status) {
    if (status === 'OK') {
      const location = {
        latitude: results[0].geometry.location.lat(),
        longitude: results[0].geometry.location.lng()
      }
      onGeoResults && onGeoResults(location)
    }
  });
}

export function allowMovement(location1, location2, locationRadius, inYards) {
  // Assuming you have access to the previous location data  
  // Calculate the distance between the current and previous location
  const distance = calculateDistance(location1, location2, inYards);
  const allow = distance >= locationRadius
  return allow
}

export function allowDistance(appLocation, appUserLocation, appLocationTracking, inYards) {
  const { locationRadius, useRadius, northWestCoordinates, southEastCoordinates } = appLocationTracking ?? {}
  const _locationRadius = locationRadius ? locationRadius : 5
  // Assuming you have access to the previous location data  
  // Calculate the distance between the current and previous location
  if (useRadius) {
    const distance = calculateDistance(appLocation, appUserLocation, inYards);
    const allow = distance <= _locationRadius
    return allow
  } else {
    return isUserWithinBounds(appUserLocation, northWestCoordinates, southEastCoordinates)
  }
}

function isUserWithinBounds(userCoordinates, nwCoordinates, seCoordinates) {
  const userLat = userCoordinates.lat;
  const userLng = userCoordinates.lng;

  const nwLat = nwCoordinates.lat;
  const nwLng = nwCoordinates.lng;

  const seLat = seCoordinates.lat;
  const seLng = seCoordinates.lng;

  return userLat >= seLat && userLat <= nwLat && userLng >= nwLng && userLng <= seLng;
}

export function calculateDistance(location1, location2, inYards) {

  const earthRadius = 3959; // Earth's radius in miles
  const yardsInMile = 1760

  const dLat = toRadians(location2.latitude - location1.latitude);
  const dLon = toRadians(location2.longitude - location1.longitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(location1.latitude)) *
    Math.cos(toRadians(location2.latitude)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;
  const distanceInYards = distance * yardsInMile

  return inYards ? distanceInYards : distance;
}

// Helper function to convert degrees to radians
function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}

export function createCenterControl(map, center) {
  const controlButton = document.createElement("button");

  // Set CSS for the control.
  controlButton.style.backgroundColor = "#fff";
  controlButton.style.border = "2px solid #fff";
  controlButton.style.borderRadius = "3px";
  controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlButton.style.color = "rgb(25,25,25)";
  controlButton.style.cursor = "pointer";
  controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
  controlButton.style.fontSize = "16px";
  controlButton.style.lineHeight = "38px";
  controlButton.style.margin = "8px 0 22px";
  controlButton.style.padding = "0 5px";
  controlButton.style.textAlign = "center";
  controlButton.textContent = "Center Map";
  controlButton.title = "Click to recenter the map";
  controlButton.type = "button";
  // Setup the click event listeners: simply set the map to Chicago.
  controlButton.addEventListener("click", () => {
    map.setCenter(center);
  });
  return controlButton;
}

export const drawingManager = (google) => {
  return new google.maps.drawing.DrawingManager({
    drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
    drawingControl: true,
    drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [google.maps.drawing.OverlayType.RECTANGLE],
    },
  })
}